import { useState } from "react";
import { $ } from "kw/api";
import { GraphQLTypes } from "kw/api/zeus";
import { useAPI } from "kw/api/useAPI";

const policyCancellationSummaryFields = {
  id: true,
  policy: {
    id: true,
    policyNumber: true,
    finishDate: true,
    quote: {
      id: true,
      userReference: true,
      paymentFrequency: true,
      periodicPrice: true,
      product: {
        name: true,
      },
    },
  },
  amountDue: true,
  effectiveDate: true,
  fees: {
    taxes: true,
    fees: true,
    stampDuty: true,
    breakdown: {
      amount: true,
      feeType: {
        key: true,
        label: true,
        kind: true,
      },
    },
  },
  data: true,
};

const policyCancellationSummaryQuery = {
  policyCancellationQuote: [
    {
      policyId: $("id", "ID!"),
    },
    policyCancellationSummaryFields,
  ],
};

const policyCancellationSummaryMutation = {
  policyCancellationSummary: [
    {
      input: $("input", "PolicyCancellationSummaryInput!"),
    },
    policyCancellationSummaryFields,
  ],
};

// TODO: Modify this after API implementation if needed
const confirmPolicyCancellationMutation = {
  confirmPolicyCancellation: [
    {
      input: $("input", "ConfirmPolicyCancellationInput!"),
    },
    {
      policyNumber: true,
      status: true,
      currentPeriod: {
        finishDate: true,
      },
      isPendingCancellation: true,
    },
  ],
};
export const usePolicyCancellationQuote = (policyId: string) => {
  const [data, setData] = useState<GraphQLTypes["PolicyCancellationQuoteType"]>();
  const { query, loading, isError, isSuccess, mutation } = useAPI();
  const fetchPolicyCancellationQuote = () => {
    query(
      policyCancellationSummaryQuery,
      (response: {
        policyCancellationQuote: GraphQLTypes["PolicyCancellationQuoteType"];
      }) => {
        setData(response?.policyCancellationQuote);
      },
      {
        id: policyId,
      }
    );
  };
  const createPolicyCancellationQuote = () => {
    mutation(
      policyCancellationSummaryMutation,
      (response: {
        policyCancellationSummary: GraphQLTypes["PolicyCancellationQuoteType"];
      }) => {
        setData(response?.policyCancellationSummary);
      },
      {
        input: {
          policyId,
        },
      }
    );
  };
  return {
    fetchPolicyCancellationQuote,
    createPolicyCancellationQuote,
    data,
    loading,
    isError,
    isSuccess,
  };
};

export const useConfirmPolicyCancellation = () => {
  const [data, setData] = useState();
  const [isCancellationSuccess, setIsCancellationSuccess] = useState<boolean>();
  const { loading, isError, isSuccess, mutation } = useAPI();
  const confirmPolicyCancellation = (
    policyId: string,
    policyCancellationQuoteId: string
  ) => {
    mutation(
      confirmPolicyCancellationMutation,
      (response) => {
        setData(response?.confirmPolicyCancellation);
        setIsCancellationSuccess(
          response?.confirmPolicyCancellation.isPendingCancellation
        );
      },
      {
        input: {
          policyId,
          policyCancellationQuoteId,
        },
      }
    );
  };
  return {
    confirmPolicyCancellation,
    data,
    isCancellationSuccess,
    loading,
    isError,
    isSuccess,
  };
};
